export default __webpack_public_path__ + "static/media/FEMUR_SAGITAL_LEFT.cc8182d1.jpg";